import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Profile from "../screens/auth/Profile";
import Category from "../screens/users/Category";
import AllProduct from "../screens/users/AllProduct";
import ProductDetailsPage from "../components/UserSideComponents/Product/ProductDetailsPage";
import CartPage from "../components/common/CartPage";
import Product from "../screens/auth/Product";
import AdminAddProduct from "../components/AdminSideComponents/DashBoardProduct/AdminAddProduct";
import AdminOrderList from "../components/AdminSideComponents/DashBoardOrder/AdminOrderList";
import Review from "../screens/auth/Review";
import Faq from "../screens/auth/Faq";
import Blog from "../screens/auth/Blog";
import Inquiry from "../screens/auth/Inquiry";
import AdminCategory from "./../screens/auth/AdminCategory";
import AdminSubCategory from "./../screens/auth/AdminSubCategory";
import AdminBanner from "./../screens/auth/AdminBanner";
import Contact from "./../screens/users/Contact";
import AdminOrderDetails from "../components/AdminSideComponents/DashBoardOrder/AdminOrderDetails";
import AdminPurchaseList from "../components/AdminSideComponents/AdminPurchase/AdminPurchaseList";
import AdminPurchaseForm from "../components/AdminSideComponents/AdminPurchase/AdminPurchaseForm";
import AdminPurchaseDetails from "../components/AdminSideComponents/AdminPurchase/AdminPurchaseDetails";
import AdminProductDetails from "../components/AdminSideComponents/DashBoardProduct/AdminProductDetails";
import AdminEditProduct from "../components/AdminSideComponents/DashBoardProduct/EditProduct";
import ProfilePage from "../components/UserSideComponents/Profile/ProfilePage";
import WishlistPage from "../components/common/WishlistPage";
import Checkout from "../screens/users/Checkout";
import UserOrders from "../screens/users/UserOrders";
import OrderDetails from "../screens/users/OrderDetails";
import Sellerregistration from "../screens/users/SelllerRegistration";
import AdminSellers from "../screens/auth/AdminSellers";
import SupplierDashboard from "../screens/supplier/SupplierDashboard";
import SupplierCategories from "../screens/supplier/SupplierCategories";
import SupplierSubCategories from "../screens/supplier/SupplierSubCategories";
import SupplierProducts from "../screens/supplier/SupplierProducts";
import SellerLogin from "../components/Seller/SellerLoginModal";
import SupplierAddProduct from "../components/Seller/SupplierAddProduct";
import SupplierEditProduct from "../components/Seller/SupplierEditProduct";
import SupplierProductDetails from "../components/Seller/SupplierProductDetails";
import SupplierProfile from "../screens/supplier/SupplierProfile";
import AdminDiscount from "../screens/auth/AdminDiscount";
import BlogDetails from "../screens/users/BlogDetails";
import Terms from "../screens/users/Terms";
import Privacy from "../screens/users/Privacy";
import AdminSellerViewPage from "../components/AdminSideComponents/AdminSeller/AdminSellerViewModal";
import Return from "../screens/users/Return";
import Shipping from "../screens/users/Shipping";
import SupplierVariants from "../screens/supplier/SupplierVariants";
import SupplierInventory from "../screens/supplier/SupplierInventory";
import SupplierOrders from "../screens/supplier/SupplierOrders";
import SupplierReturns from "../screens/supplier/SupplierReturns";
import SupplierReports from "../screens/supplier/SupplierReports";
import AdminDeliveryZone from "../screens/auth/AdminDeliveryZone";
import InventoryDashboard from "../components/AdminSideComponents/AdminInventory/InventoryDashboard";
import AllInventory from "../components/AdminSideComponents/AdminInventory/AllInventory";
import WarehouseInventory from "../components/AdminSideComponents/AdminInventory/WarehouseInventory";
import StockMovement from "../components/AdminSideComponents/AdminInventory/StockMovement";
import StockInward from "../components/AdminSideComponents/AdminInventory/StockInward";
import StockTransfer from "../components/AdminSideComponents/AdminInventory/StockTransfer";
import StockAdjustment from "../components/AdminSideComponents/AdminInventory/StockAdjustment";
import LowStockAlerts from "../components/AdminSideComponents/AdminInventory/LowStockAlerts";
import InventoryReports from "../components/AdminSideComponents/AdminInventory/InventoryReports";
import AdminReportsDashboard from "../components/AdminSideComponents/AdminReports/AdminReportsDashboard";

// Admin Routes - Only accessible by admin users
export const adminRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/admin-products",
    component: <Product />,
  },
  {
    path: "/add-products",
    component: <AdminAddProduct />,
  },
  {
    path: "/edit-product/:id",
    component: <AdminEditProduct />,
  },
  {
    path: "/admin/product-details/:id",
    component: <AdminProductDetails />,
  },
  {
    path: "/admin-orders",
    component: <AdminOrderList />,
  },
  {
    path: "/admin/orders/:id",
    component: <AdminOrderDetails />,
  },
  {
    path: "/admin-customers",
    component: <Review />,
  },
  {
    path: "/admin-sellers",
    component: <AdminSellers />,
  },
  {
    path: "/admin-inquiry",
    component: <Inquiry />,
  },
  {
    path: "/faqs",
    component: <Faq />,
  },
  {
    path: "/admin-blog",
    component: <Blog />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/admin-categories",
    component: <AdminCategory />,
  },
  {
    path: "/admin-sub-categories",
    component: <AdminSubCategory />,
  },
  {
    path: "/app-banners",
    component: <AdminBanner />,
  },
  {
    path: "/admin-discount",
    component: <AdminDiscount />,
  },
  {
    path: "/admin/sellers/:id",
    component: <AdminSellerViewPage />,
  },
  {
    path: "/admin-purchase",
    component: <AdminPurchaseList />,
  },
  {
    path: "/admin-purchase/create",
    component: <AdminPurchaseForm />,
  },
  {
    path: "/admin-purchase/edit/:id",
    component: <AdminPurchaseForm />,
  },
  {
    path: "/admin-purchase/view/:id",
    component: <AdminPurchaseDetails />,
  },
  {
    path: "/admin-delivery-zones",
    component: <AdminDeliveryZone />,
  },
  {
    path: "/admin-inventory/dashboard",
    component: <InventoryDashboard />,
  },
  {
    path: "/admin-inventory/all-inventory",
    component: <AllInventory scope="all" />,
  },
  {
    path: "/admin-inventory/admin-stock",
    component: <AllInventory scope="admin" />,
  },
  {
    path: "/admin-inventory/vendor-stock",
    component: <AllInventory scope="vendor" />,
  },
  {
    path: "/admin-inventory/warehouse",
    component: <WarehouseInventory />,
  },
  {
    path: "/admin-inventory/stock-movement",
    component: <StockMovement />,
  },
  {
    path: "/admin-inventory/stock-adjustment",
    component: <StockAdjustment />,
  },
  {
    path: "/admin-inventory/damage-loss",
    component: <StockAdjustment title="Damage & Loss Inventory" type="Damage" />,
  },
  {
    path: "/admin-inventory/repair-management",
    component: <StockAdjustment title="Repair Management Inventory" type="Repair" />,
  },
  {
    path: "/admin-inventory/returns-replacement",
    component: <StockAdjustment title="Returns & Replacement Inventory" type="Return" />,
  },
  {
    path: "/admin-inventory/stock-transfer",
    component: <StockTransfer />,
  },
  {
    path: "/admin-inventory/stock-count",
    component: <StockAdjustment title="Stock Count & Physical Recon" type="Adjustment" />,
  },
  {
    path: "/admin-inventory/reports",
    component: <InventoryReports />,
  },
  {
    path: "/admin-reports",
    component: <AdminReportsDashboard type="dashboard" />,
  },
  {
    path: "/admin-reports/dashboard",
    component: <AdminReportsDashboard type="dashboard" />,
  },
  {
    path: "/admin-reports/sales",
    component: <AdminReportsDashboard type="sales" />,
  },
  {
    path: "/admin-reports/orders",
    component: <AdminReportsDashboard type="orders" />,
  },
  {
    path: "/admin-reports/products",
    component: <AdminReportsDashboard type="products" />,
  },
  {
    path: "/admin-reports/sellers",
    component: <AdminReportsDashboard type="sellers" />,
  },
  {
    path: "/admin-reports/customers",
    component: <AdminReportsDashboard type="customers" />,
  },
  {
    path: "/admin-reports/inventory",
    component: <AdminReportsDashboard type="inventory" />,
  },
  {
    path: "/admin-reports/purchase",
    component: <AdminReportsDashboard type="purchase" />,
  },
  {
    path: "/admin-reports/payments",
    component: <AdminReportsDashboard type="payments" />,
  },
  {
    path: "/admin-reports/refunds",
    component: <AdminReportsDashboard type="refunds" />,
  },
  {
    path: "/admin-reports/tax",
    component: <AdminReportsDashboard type="tax" />,
  },
  {
    path: "/admin-reports/marketing",
    component: <AdminReportsDashboard type="marketing" />,
  },
  {
    path: "/admin-reports/shipping",
    component: <AdminReportsDashboard type="shipping" />,
  },
  {
    path: "/admin-reports/custom",
    component: <AdminReportsDashboard type="custom" />,
  },
];

// In sellerRoutes array in AllRoutes.js
export const sellerRoutes = [
  {
    path: "/seller/dashboard",
    component: <SupplierDashboard />,
  },
  {
    path: "/seller/categories",
    component: <SupplierCategories />,
  },
  {
    path: "/seller/sub-categories",
    component: <SupplierSubCategories />,
  },
  {
    path: "/seller/products",
    component: <SupplierProducts />,
  },
  {
    path: "/seller/variants",
    component: <SupplierVariants />,
  },
  {
    path: "/seller/inventory",
    component: <SupplierInventory />,
  },
  {
    path: "/seller/orders",
    component: <SupplierOrders />,
  },
  {
    path: "/seller/returns",
    component: <SupplierReturns />,
  },
  {
    path: "/seller/reports",
    component: <SupplierReports />,
  },
  {
    path: "/seller/profile",
    component: <SupplierProfile />,
  },
  {
    path: "/seller/add-product",
    component: <SupplierAddProduct />,
  },
  {
    path: "/seller/edit-product/:id",
    component: <SupplierEditProduct />,
  },
  {
    path: "/seller/product-details/:id",
    component: <SupplierProductDetails />,
  },
];

// Combine all authenticated routes
export const authRoutes = [...adminRoutes, ...sellerRoutes];

export const nonAuthRoutes = [
  {
    path: "/admin-login",
    component: <Login />,
  },
  {
    path: "/seller-login",
    component: <SellerLogin />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
  {
    path: "/seller-registration",
    component: <Sellerregistration />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/category/:id",
    component: <Category />,
  },
  {
    path: "/allproduct",
    component: <AllProduct />,
  },
  {
    path: "/product-details/:id",
    component: <ProductDetailsPage />,
  },
  {
    path: "/blog-details/:id",
    component: <BlogDetails />,
  },
  {
    path: "/cart",
    component: <CartPage />,
  },
  {
    path: "/Userprofile",
    component: <ProfilePage />,
  },
  {
    path: "/wishlist",
    component: <WishlistPage />,
  },
  {
    path: "/checkout",
    component: <Checkout />,
  },
  {
    path: "/user-orders",
    component: <UserOrders />,
  },
  {
    path: "/order-details/:orderId",
    component: <OrderDetails />,
  },
  {
    path: "/terms-conditions",
    component: <Terms />,
  },
  {
    path: "/privacy-policy",
    component: <Privacy />,
  },
  {
    path: "/return-policy",
    component: <Return />,
  },
  {
    path: "/shipping-policy",
    component: <Shipping />,
  },
];
